import type { AccessRequirement } from './accessPolicy.types';
import { ShigoPermission } from './permissions';

export function resolvePublisherAccessRequirement(pathname: string): AccessRequirement | null {
  if (pathname === '/supply/publishers/create') {
    return {
      allOf: [ShigoPermission.SupplyRead, ShigoPermission.SupplyPublishersCreate],
    };
  }
  if (pathname.startsWith('/supply/publishers/edit/')) {
    return {
      allOf: [ShigoPermission.SupplyRead, ShigoPermission.SupplyPublishersEdit],
    };
  }

  const tabPermission = resolvePublisherTabPermission(pathname);
  if (tabPermission) {
    return {
      allOf: [ShigoPermission.SupplyRead, ShigoPermission.SupplyPublishersRead, tabPermission],
    };
  }
  if (/^\/supply\/publishers\/[^/]+\/details\/?$/.test(pathname)) {
    return {
      allOf: [ShigoPermission.SupplyRead, ShigoPermission.SupplyPublishersRead],
      anyOf: publisherTabReadPermissions,
    };
  }
  if (pathname === '/supply/publishers') {
    return {
      allOf: [ShigoPermission.SupplyRead, ShigoPermission.SupplyPublishersRead],
    };
  }
  return null;
}

const publisherTabReadPermissions = [
  ShigoPermission.SupplyPublishersOverviewRead,
  ShigoPermission.SupplyPublishersAppsRead,
  ShigoPermission.SupplyPublishersDomainsRead,
  ShigoPermission.SupplyPublishersPlacementsRead,
  ShigoPermission.SupplyPublishersAppRequestsRead,
  ShigoPermission.SupplyPublishersA2vRead,
] as const;

const publisherTabPermissions = {
  overview: ShigoPermission.SupplyPublishersOverviewRead,
  apps: ShigoPermission.SupplyPublishersAppsRead,
  domains: ShigoPermission.SupplyPublishersDomainsRead,
  placements: ShigoPermission.SupplyPublishersPlacementsRead,
  'app-requests': ShigoPermission.SupplyPublishersAppRequestsRead,
  a2v: ShigoPermission.SupplyPublishersA2vRead,
} as const;

function resolvePublisherTabPermission(pathname: string) {
  const match = /^\/supply\/publishers\/[^/]+\/details\/([^/]+)$/.exec(pathname);
  if (!match) return null;
  const tab = match[1];
  return tab && tab in publisherTabPermissions
    ? publisherTabPermissions[tab as keyof typeof publisherTabPermissions]
    : null;
}
